var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:[_vm.asset, _vm.size, _vm.aspectRatio],attrs:{"draggable":false,"src":_vm.assetUrl,"alt":"asset"}})
}
var staticRenderFns = []

export { render, staticRenderFns }